import React, { useState } from "react";
import { Mic, ChevronLeft, MicVocal } from "lucide-react";

const PreviewSpeechRecognizer = ({ data }) => {
  const targetText = data.text;
  const [isListening, setIsListening] = useState(false);
  const [recognizedText, setRecognizedText] = useState("");
  const [feedback, setFeedback] = useState("");

  // Initialize SpeechRecognition
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();

  recognition.continuous = false;
  recognition.interimResults = false;
  recognition.lang = "en-US";

  const trimPunctuation = (text) => {
    return text.replace(/[.,]/g, "").trim().toLowerCase();
  };

  recognition.onresult = (event) => {
    const transcript = event.results[0][0].transcript.trim().toLowerCase();
    const cleanedTargetText = trimPunctuation(targetText);
    setRecognizedText(transcript);

    setFeedback(
      transcript === cleanedTargetText
        ? "Correct pronunciation!"
        : "Wrong pronunciation. Try again!"
    );

    setIsListening(false);
  };

  recognition.onerror = (event) => {
    console.error("Speech recognition error:", event.error);
    setFeedback("An error occurred. Please try again.");
    setIsListening(false);
  };

  const toggleListening = () => {
    if (isListening) {
      recognition.stop();
      setIsListening(false);
    } else {
      recognition.start();
      setIsListening(true);
      setFeedback(""); // Reset feedback
    }
  };

  return (
    <div
    className="font-sans p-6 bg-gray-100 rounded-lg shadow-md text-center relative"
    style={{
      paddingBottom: "60px", // Increased bottom padding for button
    }}
  >
    <h2 className="text-2xl font-bold mb-4">Speech Practice</h2>
  
    {/* Display the target text */}
    <div
      className="mb-4 p-2 bg-white rounded-lg shadow-sm flex justify-center items-center"
      style={{
        minHeight: "60px", // Ensures a minimum height
         // Prevents excessive width
        padding: "10px", // Adds spacing
        wordWrap: "break-word", // Allows text to break within the container
        overflowWrap: "break-word", // Ensures proper text wrapping
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <p className="text-2xl font-bold text-blue-600">{targetText}</p>
    </div>
  
    {/* Display recognized text and feedback */}
    {recognizedText && (
      <div className="mt-4">
        <p className="text-lg font-medium">You said:</p>
        <p className="text-xl text-gray-700">{recognizedText}</p>
      </div>
    )}
  
    {feedback && (
      <div className="mt-4 mb-4">
        <p
          className={`text-lg font-bold ${feedback.includes("Correct") ? "text-green-600" : "text-red-600"}`}
        >
          {feedback}
        </p>
      </div>
    )}
  
    {/* Button to start/stop speech recognition */}
    <button
      onClick={toggleListening}
      className={`absolute bottom-4 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-full mt-2 text-white shadow-lg ${isListening ? "bg-red-500" : "bg-blue-500"}`}
      style={{ fontSize: "20px" }}
    >
      <Mic />
    </button>
  </div>
  
  
  );

};

export default PreviewSpeechRecognizer;
